<template>
  <div class="empty-view">
    <img src="@/assets/img/empty_0.svg">
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.empty-view {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>